import { render, staticRenderFns } from "./ReviewProjectForms.vue?vue&type=template&id=18ca6e18"
import script from "./ReviewProjectForms.vue?vue&type=script&lang=js"
export * from "./ReviewProjectForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports